import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/inspection-made-by/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/inspection-made-by/list`, { params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/inspection-made-by/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/inspection-made-by/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/inspection-made-by/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/inspection-made-by/delete/${id}`)
    },
}